import { useEffect, useState } from 'react';
import supabase from '@/lib/supabaseClient';
import { getActiveRegionConfig, getPortalHeaders } from '@/lib/regionConfig';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

/** { active, staff_email, until } for the current session; { active: false } while loading or on any error. */
export function useStaffSession() {
  const [status, setStatus] = useState({ active: false });
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) return;
        const res = await fetch(`${API_URL}/api/staff-session`, {
          headers: { Authorization: `Bearer ${session.access_token}`, ...getPortalHeaders(getActiveRegionConfig()) },
        });
        if (res.ok && !cancelled) setStatus(await res.json());
      } catch (err) {
        // Not a staff session if we cannot tell; the server enforces the real rules.
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return status;
}
